import React from 'react';
import { SiGmail } from 'react-icons/si';

const PillBadge = ({ label, variant = 'applied', theme = 'light', icon = null, compact = false }) => {
  const colors = {
    applied: { bg: '#ffffff', text: '#41a956', border: 'rgba(0,0,0,0.06)', icon: '#41a956' },
    attempted: { bg: '#ffffff', text: '#b88600', border: 'rgba(0,0,0,0.06)', icon: '#b88600' },
    neutral: { bg: '#ffffff', text: '#5fbec5', border: 'rgba(0,0,0,0.06)', icon: '#5fbec5' }
  };
  const c = colors[variant] || colors.neutral;
  const darkBg = '#121212';
  const padding = compact ? '4px 8px' : '6px 10px';
  const fontSize = compact ? '.65rem' : '.75rem';
  const iconSize = compact ? 12 : 14;
  const borderRadius = compact ? 6 : 8;

  const style = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: compact ? 6 : 8,
    padding,
    borderRadius,
    boxShadow: 'inset 0 -2px 0 rgba(0,0,0,0.03)',
    border: `1px solid ${c.border}`,
    background: theme === 'dark' ? darkBg : c.bg,
    color: theme === 'dark' ? (variant === 'applied' ? '#41a956' : variant === 'attempted' ? '#b88600' : '#5fbec5') : c.text,
    fontSize,
    fontWeight: 600,
    whiteSpace: 'nowrap'
  };

  const Icon = icon || SiGmail;

  return (
    <span style={style} aria-hidden>
      <Icon style={{ color: style.color, width: iconSize, height: iconSize }} />
      <span style={{ fontSize, color: style.color }}>{label}</span>
    </span>
  );
};

export default PillBadge;
